module.exports = __webpack_public_path__ + "img/SL-M-220-260.888ac455.svg";